<template>
    <div class="experience-entry" v-scroll-reveal>

        <div class="job-info">
            <h3><img :src="`img/emoji/${emoji}.svg`" :alt="`${emoji} emoji`">{{company}}</h3>
            <p><img src="img/emoji/bust_in_silhouette.svg" alt="Person emoji">{{jobtitle}}</p>
            <p><img src="img/emoji/calendar_spiral.svg" alt="Calendar emoji">{{dates}}</p>
        </div>

        <div class="job-summary">
            <p v-for="bullet in bulletpoints" :key="bullet.id">{{bullet}}</p>
        </div>

    </div>
</template>

<script>

export default {
  props: ['company', 'dates', 'jobtitle', 'bulletpoints', 'emoji']
}

</script>

<style lang="scss" scoped>

.experience-entry {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $grid-gap;

    @include phone-only {
        flex-direction: column;
    }

    &:nth-of-type(odd) {
      background-color: $gray1;
    }

    .job-info {
        width:50%;
        padding-right: 5%;
        box-sizing: border-box;
        align-self: self-start;

        @include phone-only {
            width: 100%;
            padding: 0;
            margin-bottom: .8rem;
        }

        h3 {
            font-family: $title-font;
            font-size: 1.5rem;
            line-height: 2.25rem;
            margin-bottom: .5rem;

            img {
                width: 1.75rem;
                margin-right: .5rem;
                margin-bottom: -.125rem;
            }

        }

        p {
            color: $gray8;
            margin-bottom: .25rem;

            img {
                width: 1rem;
                margin-right: .5rem;
                margin-bottom: -.125rem;
                opacity: .4;
            }
        }
    }
    .job-summary {
        width:50%;
        max-width: 650px;

        @include phone-only {
            width: 100%;
        }

        p {
            margin-top: .8rem;
            padding-top: .8rem;
            border-top: 1px solid rgba(0, 0, 0, 0.1);

            &:before {
                font-weight: 800;
            }

            &:first-of-type {
                @include tablet-up {
                    margin-top: 0;
                    padding-top: 0;
                    border-top: none;
                }

                @include phone-only {
                    margin-top: 0;
                }
            }

        }
    }
}

</style>
